var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff8fb8",
    d: "M512 106.973v255c0 33.09-33.63 60-75 60-19.64 0-37.55-6.07-50.92-15.98-14.8-10.97-24.08-26.64-24.08-44.02s9.28-33.05 24.08-44.02c13.37-9.91 31.28-15.98 50.92-15.98 16.95 0 32.43 4.69 45 12.3v-124.55l-95.92 41.11-84.08 36.03v185.11c0 33.09-33.63 60-75 60s-75-26.91-75-60 33.63-60 75-60c16.95 0 32.43 4.69 45 12.3v-207.3c0-6.01 3.57-11.43 9.08-13.78l210-90c4.66-2.03 9.99-1.51 14.18 1.26 4.22 2.78 6.74 7.48 6.74 12.52z",
    opacity: 1,
    "data-original": "#ff8fb8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#979fef",
    d: "M240 164.973c0 35.099-30.901 67.2-34.501 70.499-5.7 6-15.298 6-20.999 0-6-5.7-6-15.3 0-21 6.899-7.2 25.499-30 25.499-49.499 0-32.1-32.999-78.9-60-111v216c0 2.399-.3 5.4-.601 8.399-2.999 16.201-13.799 30.3-29.399 39.6-12.299 7.5-28.2 12.001-45 12.001-41.4 0-75-27.001-75-60 0-33.001 33.6-60 75-60 17.1 0 32.401 4.799 45 12.299V14.973c0-6 3.6-11.4 9.3-13.801s12.299-.899 16.199 3.3C155.4 14.072 240 100.773 240 164.973z",
    opacity: 1,
    "data-original": "#979fef"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b77e8",
    d: "M240 164.973c0 35.099-30.901 67.2-34.501 70.499-5.7 6-15.298 6-20.999 0-6-5.7-6-15.3 0-21 6.899-7.2 25.499-30 25.499-49.499 0-32.1-32.999-78.9-60-111v216c0 2.399-.3 5.4-.601 8.399-2.999 16.201-13.799 30.3-29.399 39.6V14.973c0-6 3.6-11.4 9.3-13.801s12.299-.899 16.199 3.3C155.4 14.072 240 100.773 240 164.973z",
    opacity: 1,
    "data-original": "#6b77e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f96",
    d: "M505.26 94.453c-4.19-2.77-9.52-3.29-14.18-1.26l-105 45v92.64l95.92-41.11v124.55c-12.57-7.61-28.05-12.3-45-12.3-19.64 0-37.55 6.07-50.92 15.98-14.8 10.97-24.08 26.64-24.08 44.02s9.28 33.05 24.08 44.02c13.37 9.91 31.28 15.98 50.92 15.98 41.37 0 75-26.91 75-60v-255c0-5.04-2.52-9.74-6.74-12.52z",
    opacity: 1,
    "data-original": "#ff5f96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.5a3343d7aa935a07ef2cf8d64d8977dd.svg";
export { ForwardRef as ReactComponent };